import React from "react";
import "./table-location-button.component.scoped.scss";
import { Button } from "@material-ui/core";
import { icons } from "../../statics/icons";
const { homeIco } = icons;

export default function TableLocationButton(props: any) {
  return (
    <Button
      className="location-btn text-capitalize"
      variant="contained"
      color="primary"
    >
      <img src={homeIco} alt="home" />
      <span>{props.location}</span>
    </Button>
  );
}
